import type { ModuleKey, TableName } from "./types";

export const STORAGE_KEY = "ritual_v2";
export const LOCAL_DB_NAME = "ritual_cloud_v1";
export const LOCAL_DB_VERSION = 1;

export const CATEGORIES = {
  nutrition: ["Supplement", "Dry Fruit", "Fruit", "Protein", "Vegetable", "Other"],
  wardrobe: ["Tops", "Bottoms", "Outerwear", "Ethnic", "Formal", "Accessories", "Other"],
  learning: ["Tech", "Health", "Finance", "Philosophy", "Language", "Creative", "Other"],
};

export const LEARNING_TYPES = ["Book", "Course", "Podcast", "Video Series", "Article", "Other"];
export const GROOMING_INTERVALS = [1, 2, 3, 5, 7, 10, 14, 21, 30];

export const MODULE_TO_TABLE: Record<ModuleKey, TableName> = {
  nutrition: "nutrition_items",
  grooming: "grooming_items",
  wardrobe: "wardrobe_items",
  learning: "learning_items",
};

export const TABLE_TO_MODULE: Partial<Record<TableName, ModuleKey>> = {
  nutrition_items: "nutrition",
  grooming_items: "grooming",
  wardrobe_items: "wardrobe",
  learning_items: "learning",
};

export const MODULE_LABEL: Record<ModuleKey, string> = {
  nutrition: "Nutrition",
  grooming: "Grooming",
  wardrobe: "Wardrobe",
  learning: "Learning",
};
